import { Router, ActivatedRoute } from '@angular/router';
import { AdminService } from './../../../_services/admin.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-level',
  templateUrl: './edit-level.component.html',
  styleUrls: ['./edit-level.component.css']
})
export class EditLevelComponent implements OnInit {
  myForm:FormGroup=undefined
  loading =false
  saving=false
  level:any=undefined
  errorSaving=false
  constructor(private adminService:AdminService, private router:Router,private activatedRoute:ActivatedRoute) { }
  get f() {
    return this.myForm.controls
  }
  ngOnInit(): void {
    this.activatedRoute.params.subscribe(
      myP=>{
        this.loading=true
        this.adminService.getLevel(myP['server_level_id']).subscribe(
          myLevel=>{
            this.level=myLevel
            this.initMainForm()
            this.loading=false
          }
        )
      }
    )


  }
  on_submit(){
    this.saving=true
    let dd=this.formatData(this.myForm.value.name,this.myForm.value.level_short_name, this.myForm.value.description, this.myForm.value.ordinal_number)

    this.adminService.editLevel(dd).subscribe(
      val=>{

        this.saving=false
        if(val['server_fact_id']==0){
          this.errorSaving=true
        }
        else{

          this.router.navigate(['/admin/levels/show',val['server_level_id']])
        }

      }
    )

  }
  formatData(body:string, explanation:string,truth:number, ordinal_number:number){
    let data = new URLSearchParams();
    data.set('name', body);
    data.set('level_short_name', explanation);
    data.set('ordinalNumber', ordinal_number.toString());
    data.set('description', truth.toString());
    data.set('id', this.level.server_level_id.toString());
    return data.toString()
  }
  initMainForm(){

    this.myForm=new FormGroup({
      name: new FormControl(this.level.name, [Validators.required,Validators.minLength(4)]),
      ordinal_number:new FormControl(this.level.ordinal_number, [Validators.required]),
      level_short_name: new FormControl(this.level.level_short_name, [Validators.required,Validators.minLength(3)]),
      description: new FormControl(this.level.description, [Validators.required]),
    });
  }


 }
